<script>
    import {Toast} from 'vant';
    import Config from '@/config';
    import {gzUnbind} from '@/api';
    import {wxClose} from '@/libs/util';

    export default {
        name: 'GzUnbind',
        created() {
            if (!this.$route.query.token) {
                return;
            }

            gzUnbind(this.$route.query.token).then(response => {
                if (response.data.code === Config.successCode) {
                    Toast.success('解绑成功');
                }
            }).finally(() => {
                wxClose();
            });
        }
    }
</script>

<template>
    <div class="gz-unbind">

    </div>
</template>
